/**
 * Identity Verification API URLs
 */

import type { IdentityVerification } from './types'

/**
 * 본인인증 시작
 * POST /identity-verification/{provider}/initiate
 */
export const API_IDENTITY_VERIFICATION_INITIATE = (provider: IdentityVerification) =>
  `/identity-verification/${provider}/initiate`

/**
 * 사용자의 본인인증 여부 조회 (기존 회원에 대한 본인인증 여부 조회)
 * GET /account/user/identity-verification
 */
export const API_IDENTITY_VERIFICATION_STATUS = '/account/user/identity-verification'
